module.exports = __webpack_public_path__ + "static/media/yandex-maps.3ec2c492.png";